import Icon from "@ant-design/icons";

import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;
const AttendanceSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      fill="currentColor"
      d="M5.075 12H8q.275 0 .525.138t.375.412l1.1 2.2l3.1-6.2q.275-.575.9-.575t.9.575L16.625 12h2.3Q18.55 9.45 16.6 7.725T12 6T7.4 7.725T5.075 12M16.6 18.275Q18.55 16.55 18.925 14H16q-.275 0-.525-.137t-.375-.413l-1.1-2.2l-3.1 6.2q-.275.575-.9.575t-.9-.575L7.375 14h-2.3q.375 2.55 2.325 4.275T12 20t4.6-1.725m-8.087 3.013q-1.638-.713-2.863-1.938t-1.937-2.863T3 13h2q0 2.9 2.05 4.95T12 20t4.95-2.05T19 13h2q0 1.85-.712 3.488T18.35 19.35t-2.863 1.938T12 22t-3.488-.712M3 13q0-1.85.713-3.488T5.65 6.65t2.863-1.937T12 4q1.55 0 2.975.5t2.675 1.45l1.4-1.4l1.4 1.4l-1.4 1.4Q20 8.6 20.5 10.025T21 13h-2q0-2.9-2.05-4.95T12 6T7.05 8.05T5 13zM9 3V1h6v2zM7.05 17.95Q5 15.9 5 13t2.05-4.95T12 6t4.95 2.05T19 13t-2.05 4.95T12 20t-4.95-2.05M12 13"
    />
  </svg>
);
const AttendanceIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={AttendanceSvg} {...props} />
);
export default AttendanceIcon;
